// Renders one or more FontAwesome icons for a category
const CategoryIcon = ({ icons = [], className = "", style = {} }) => {
  if (!icons || icons.length === 0) {
    return (
      <span className={className} style={style}>
        <i className="fa-solid fa-heart" aria-hidden="true" />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center justify-center gap-0.5 ${className}`} style={style}>
      {icons.map((c, i) => (
        <i key={i} className={c} aria-hidden="true" />
      ))}
    </span>
  );
};

export default CategoryIcon;
